<script>
  export let fundsItem;
  export let key;
  export let active = false;
  export let selectUnitsInfo;
</script>

<div class="accordion-item mb-2">
  <h2
    class="accordion-header"
    id="headingOne"
  >
    <button
      class="accordion-button shadow-none {active
        ? ''
        : 'collapsed'} blue-color py-2 px-3 font-size-13 text-break"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#collapse{key}"
      aria-expanded="true"
      aria-controls="collapse{key}"
    >
      {fundsItem.name}
    </button>
  </h2>
  <div
    id="collapse{key}"
    class="accordion-collapse collapse {active ? 'show' : ''}"
    aria-labelledby="headingOne"
    data-bs-parent="#accordionFunds{key}"
  >
    <div class="accordion-body py-2 px-2">
      <div class="fund-title-block">
        <strong class="font-size-14px font-weight-500 d-block color-blue">Fund Name</strong>
        <span class="font-weight-500 d-block"> {fundsItem.name}</span>
      </div>
      <div class="content-block rounded p-2 mt-2">
        <div class="row mb-3">
          {#if selectUnitsInfo.usCompliance}
            <div class="col-md-4">
              <span class="title d-block mb-1 color-blue font-weight-500">CCC</span>
              <span class="text-break">{fundsItem.ccc}</span>
            </div>
            <div class="col-md-4">
              <span class="title color-blue d-block mb-1 font-weight-500">PMAC</span>
              <span class="text-break">{fundsItem.pmac}</span>
            </div>
          {/if}
          <div class="col-md-4">
            <span class="title color-blue d-block mb-1 font-weight-500">CIK</span>
            <span class="text-break">{fundsItem.cik}</span>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-4">
            <span class="title color-blue d-block mb-1 font-weight-500">Passphrase</span>
            <span class="text-break">{fundsItem.passphrase}</span>
          </div>
          <div class="col-md-4">
            <span class="title color-blue d-block mb-1 font-weight-500">Password</span>
            <span class="text-break">{fundsItem.password}</span>
          </div>
        </div>
        {#if selectUnitsInfo.usCompliance}
          <div class="row mb-3">
            <div class="col-md-4">
              <span class="title color-blue d-block mb-1 font-weight-500">Renewal</span>
              <span>{fundsItem.renewal === 1 ? 'Yes' : 'No'} </span>
            </div>

            <div class="col-md-4">
              <span class="title color-blue d-block mb-1 font-weight-500"
                >Form D Annual Filing Date</span
              >
              <div class="d-flex flex-row align-items-center">
                <div class="me-1">
                  {#if fundsItem.renewal == 1}
                    <img
                      class="opacity-50 img-calendar icon-16 ms-1"
                      alt=""
                      src="/images/calendar.svg"
                    />
                  {/if}
                </div>

                {#if fundsItem.renewal == 1}
                  <span>{fundsItem.renewalDateFormat}</span>
                {/if}
              </div>
            </div>
          </div>
          <div class="row mb-2">
            <div class="col-md-4">
              <span class="title color-blue d-block mb-1 font-weight-500">BlueSky Fillings</span>
            </div>
          </div>
          <div class="mb-3">
            {#each fundsItem.blueskys as blueskys, i}
              <div class="row mb-2">
                <div class="col-md-4">
                  <div class="checkbox c-checkbox">
                    <label
                      for=""
                      class="text-break"
                    >
                      {blueskys.name}
                    </label>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="d-flex flex-row align-items-center">
                    <div class="me-1">
                      <img
                        class="opacity-50 img-calendar icon-16 ms-1"
                        alt=""
                        src="/images/calendar.svg"
                      />
                    </div>
                    <span>{blueskys.dateFormat}</span>
                  </div>
                </div>
              </div>
            {/each}
          </div>
        {/if}

        {#if !selectUnitsInfo.outsourcedCfo}
          <div class="row mb-2">
            <div class="col-md-12">
              <span class="title color-blue d-block mb-1 font-weight-500">Fund Notes</span>
              <p class="mt-0">
                {fundsItem.notes}
              </p>
            </div>
          </div>
        {/if}
      </div>
    </div>
  </div>
</div>

<style lang="scss">
  .accordion-item {
    .accordion-collapse {
      border-color: $input-border-color;
    }
    .content-block {
      border: 1px solid $input-border-color;
      background: $light-blue-color;
    }
    .accordion-button:not(.collapsed) {
      background-color: $light-blue-color;
    }
    button:not(:disabled):active {
      background-color: $light-blue-color;
    }
  }
</style>
